export const collectionsEn = {
  // BEGIN Michael
  COLLECTIONS_SEARCH_PLACEHOLDER: 'Search invoice or reference number...',
  COLLECTIONS_SHOWING_INVOICES: 'Showing {0} of {1} invoices',
  COLLECTIONS_LOADING_MORE_INVOICES: 'Loading more invoices...',
  // END Michael
  // BEGIN Fco
  // END Fco
  // BEGIN Fabian
  COLLECTIONS: 'Collections',
  COLLECTION: 'Collection',
  HIDE_COLLECTION_UPDATE_TODAY: 'Hide Collection Updated Today',
  UPDATE_INVOICE_COLLECTION_SUCCESS: 'Invoice Collection Updated Successfully',
  INELIGIBLE: 'Ineligible',
  DISPUTED: 'Disputed',
  // END Fabian
  DAYS_AGED: 'Days Aged',
  DAYS_OUTSTANDING: 'Days Outstanding',
  OVER_30_DAYS: 'Over 30 Days',
  CURRENT: 'Current',
  COLLECTION_STATUS: 'Collection Status',
  CREATE_COLLECTION_STATUS_SUCCESS: 'Collection status created successfully',
  UPDATE_COLLECTION_STATUS_SUCCESS: 'Collection status updated successfully',
  TITLE_CREATE_COLLECTION_STATUS: 'Create Collection Status',
  TITLE_UPDATE_COLLECTION_STATUS: 'Update Collection Status',
  COLLECTION_STATUS_COLOUR: 'Color',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
}

export const collectionsEs: typeof collectionsEn = {
  // BEGIN Michael
  COLLECTIONS_SEARCH_PLACEHOLDER: 'Buscar número de factura o de referencia...',
  COLLECTIONS_SHOWING_INVOICES: 'Mostrando {0} de {1} facturas',
  COLLECTIONS_LOADING_MORE_INVOICES: 'Cargando más facturas...',
  // END Michael
  // BEGIN Fco
  // END Fco
  // BEGIN Fabian
  COLLECTIONS: 'Cobranzas',
  COLLECTION: 'Cobranza',
  HIDE_COLLECTION_UPDATE_TODAY: 'Ocultar Cobranzas Actualizadas Hoy',
  UPDATE_INVOICE_COLLECTION_SUCCESS: 'Cobranza Actualizada Correctamente',
  INELIGIBLE: 'Inelegible',
  DISPUTED: 'Disputado',
  // END Fabian
  DAYS_AGED: 'Días de Antigüedad',
  DAYS_OUTSTANDING: 'Días Pendientes',
  OVER_30_DAYS: 'Sobre 30 Días',
  CURRENT: 'Corriente',
  COLLECTION_STATUS: 'Estado de Cobranza',
  CREATE_COLLECTION_STATUS_SUCCESS: 'Estado de cobranza creado exitosamente',
  UPDATE_COLLECTION_STATUS_SUCCESS: 'Estado de cobranza actualizado exitosamente',
  TITLE_CREATE_COLLECTION_STATUS: 'Crear Estado de Cobranza',
  TITLE_UPDATE_COLLECTION_STATUS: 'Actualizar Estado de Cobranza',
  COLLECTION_STATUS_COLOUR: 'Color',
  ACTIVE: 'Activo',
  INACTIVE: 'Inactivo',
}
